export const tileStatus = {
  AVAILABLE: 1,
  DISABLE: 2,
  HIDDEN: 3,
  USER_LEVEL_ONE_FEATURE: 1.5,
}
